import { Field, reduxForm } from "redux-form";
import { Modal } from "components";
import { Button, Input } from "expano-components";
import { updateSpeditor } from "actions/speditors";

import { ReactComponent as EditIcon } from "icons/edit.svg";
import { useMainList } from "components/MainList/context/provider";

const InputField = (props) => <Input {...props} />;

const ModalEditSpeditor = ({
  id,
  invalid,
  pristine,
  handleSubmit,
  handleClose,
}) => {
  const { refetch } = useMainList();

  const onSubmit = async (values) => {
    try {
      await updateSpeditor(id, values);
      handleClose();
      refetch();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal
      size="md"
      handleClose={handleClose}
      header={{
        icon: <EditIcon />,
        title: "Edycja",
      }}
      footer={
        <>
          <Button type="cancel" text="Anuluj" onClick={handleClose} />
          <button
            disabled={invalid || pristine}
            onClick={handleSubmit(onSubmit)}
            type="submit"
            className="btn btn-sm btn-green"
          >
            <span>Zapisz</span>
          </button>
        </>
      }
    >
      <form noValidate>
        <table className="modal-table">
          <tbody>
            <tr>
              <td>Nazwa</td>
              <td>
                <Field placeholder="Nazwa" name="name" component={InputField} />
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </Modal>
  );
};

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Pole wymagane!";
  }
  return errors;
};

export default reduxForm({
  form: "edit-speditor",
  validate,
  enableReinitialize: true,
})(ModalEditSpeditor);
